<ng-container *ngIf="loginStatus">
  <!-- header -->
  <app-header></app-header>

  <section class="container-fluid page-body-wrapper">
    <!-- Sidebar -->
    <app-sidebar></app-sidebar>

    <div class="main-panel" (click)="closeSidebar($event)">
      <app-loader></app-loader>
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>

  </section>
</ng-container>
<ng-container *ngIf="!loginStatus">
  <app-loader></app-loader>
  <router-outlet></router-outlet>
</ng-container>